import type { PageContext } from 'vike/types'
import { cleanAddressPart, type PageDataBase } from '@repo/ui'
export default function title(pageContext: PageContext<PageDataBase>): string {
  const { mode, place } = pageContext.routeParams
  const { page } = pageContext.data
  const name = pageContext.locale === 'ja' ? page?.name : page?.roman ?? page?.name
  const key = `seo.hub.${mode}.${place ? 'area' : 'nationwide'}.title`
  return pageContext.i18n.global.t(key, { area: cleanAddressPart(name ?? '') })
}
